/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderCopyCustomerCompany } from './order_copy_customer_company'
/**
 * Заказчик
 */
export type OrderCopyCustomer = {
  /**
   * Тип заказчика
   */
  type: OrderCopyCustomer.type
  /**
   * Компания (юр. лицо). Обязательно при type=Legal, не указывается при type=Individual
   */
  company: null | OrderCopyCustomerCompany
}
export namespace OrderCopyCustomer {
  /**
   * Тип заказчика
   */
  export enum type {
    LEGAL = 'legal',
    INDIVIDUAL = 'individual'
  }
}
